import khaneBalaVilla from "../../img/slider-images/khane bala villa.jpg";
import lotus from "../../img/slider-images/Lotus.jpg";
import paradise from "../../img/slider-images/Paradise.jpg";
import mom from "../../img/slider-images/mom.jpg";
import image2 from "../../img/slider-images/2.jpg";
import image4 from "../../img/slider-images/4.jpg";
import image8 from "../../img/slider-images/8.jpg";
import image7 from "../../img/slider-images/07.JPG";

export const sliderData = [
  {
    id: 1,
    src: khaneBalaVilla,
    desc: "Iran,Mazandaran",
    title: "khane bala villa",
  },
  {
    id: 2,
    src: mom,
    desc: "Tehran,Ajoodanieh",
    title: "lotus apartment",
  },
  {
    id: 3,
    src: image2,
    desc: "Tehran,Farmanieh",
    title: "paradise apartment",
  },
  {
    id: 4,
    src: image4,
    desc: "Tehran,Farmanieh",
    title: "paradise apartment",
  },
  {
    id: 5,
    src: image8,
    desc: "Tehran,Farmanieh",
    title: "paradise apartment",
  },
  {
    id: 6,
    src: lotus,
    desc: "Tehran,Farmanieh",
    title: "paradise apartment",
  },
  {
    id: 7,
    src: image7,
    desc: "Tehran,Farmanieh",
    title: "paradise apartment",
  },
  {
    id: 8,
    src: paradise,
    desc: "Tehran,Farmanieh",
    title: "paradise apartment",
  },
];
